import { render, staticRenderFns } from "./RevenueInfo.vue?vue&type=template&id=57db947c&scoped=true&"
import script from "./RevenueInfo.vue?vue&type=script&lang=js&"
export * from "./RevenueInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db947c",
  null
  
)

export default component.exports